export const INITIAL_REEL_STATUS = 'pending';
export const QUEUED_REEL_STATUS = 'queued';
export const PROCESSING_REEL_STATUS = 'processing';
export const PROCESSED_REEL_STATUS = 'processed';

const reelStatusList = [
    INITIAL_REEL_STATUS,
    QUEUED_REEL_STATUS,
    PROCESSING_REEL_STATUS,
    PROCESSED_REEL_STATUS,
] as const;

export type ReelStatus = (typeof reelStatusList)[number];

export const REAL_FOOTAGE_AND_AUDIO_CONTENT_LABEL = 'real-footage-and-audio';
export const GENERATED_FOOTAGE_AND_REAL_AUDIO_CONTENT_LABEL =
    'generated-footage-and-real-audio';
export const GENERATED_FOOTAGE_AND_AUDIO_CONTENT_LABEL =
    'generated-footage-and-audio';
export const REAL_FOOTAGE_AND_GENERATED_AUDIO_CONTENT_LABEL =
    'real-footage-and-generated-audio';
export const UNKNOWN_CONTENT_LABEL = 'unknown';

const contentLabelList = [
    UNKNOWN_CONTENT_LABEL,
    REAL_FOOTAGE_AND_AUDIO_CONTENT_LABEL,
    REAL_FOOTAGE_AND_GENERATED_AUDIO_CONTENT_LABEL,
    GENERATED_FOOTAGE_AND_REAL_AUDIO_CONTENT_LABEL,
    GENERATED_FOOTAGE_AND_AUDIO_CONTENT_LABEL,
] as const;

export type ContentLabel = (typeof contentLabelList)[number];

export type Reel = {
    id: number;
    team_id: number;
    organisation_id: number;
    clip_id: number;
    created_by: number;
    code: string;
    name: string;
    created_at: string;
    updated_at: string;
    content_label: ContentLabel;
    status: ReelStatus;
    data: ClipData;
    video_url: string;
    captions_url: string;
    reviewed_captions_url?: string;
    flow_count?: number;
    creator?: {
        id: number;
        name: string;
        profile_photo_path?: string;
    } | null;
    thumbnail?: string;
    screenshot?: string;
};

export type ClipData = {
    video: {
        path: string;
        size: number;
        duration: number;
        original_filename?: string;
    };
    // NOTE: The VTT file as it was generated by the pipeline
    captions: {
        path: string;
        size: number;
    };
    // NOTE: The VTT file as it was reviewed and/or edited by the user
    reviewed_captions?: {
        path: string;
        size: number;
    };
    content_label?: ContentLabel;
};

export type VttChunk = {
    startTimeMs: number;
    endTimeMs: number;
    text: string;
};
